module.exports = __webpack_public_path__ + "d61c804b320ba42e129d6f96af8b0eb4.pdf";